import React, { useCallback, useState } from 'react';
import { Card } from 'mui';
import { Button } from 'mui';
import GoogleIcon from 'images/google-icon-color.svg';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { hotjarIdentity, segmentAlias } from 'app/utils';
import { push } from 'connected-react-router/immutable';
import * as Routes from 'app/constants/Routes';
import { guestRegistrationTermsSubmitted, hardRedirectRequested, LOGIN_WITH_GOOGLE, NOOP } from 'app/actions/customer';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import AccountRegistrationStep from 'app/components/customer/Registration/Parts/Step4';

const LoginType = ({ allValues, trackSegmentEvent = false }) => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [withEmail, setWithEmail] = useState(false);
  const onSubmitSendData = useCallback(
    async (email, token) => {
      const action = {
        params: {
          ...Object.values(allValues as Record<string, Record<string, any>>).reduce(
            (reduced, val) => ({ ...reduced, ...val }),
            {},
          ),
          email,
          oauth_provider: 'google',
          href: window.location.href,
          referrer: window.referrer,
        },
        context: {
          onSuccessActionCreator: ({ json: { registration_feedback, user_id } }) => {
            if (user_id) {
              hotjarIdentity(user_id);
              segmentAlias(user_id);
            }
            if (registration_feedback === 'google_account_exist') {
              return {
                type: LOGIN_WITH_GOOGLE,
                params: { token },
                context: {
                  onSuccessActionCreator: ({ json: { path } }) => hardRedirectRequested(path),
                  onFailureActionCreator: () => {
                    return { type: NOOP };
                  },
                },
              };
            }
            if (registration_feedback) {
              return push(`${Routes.Registration}?registration_feedback=${registration_feedback}`);
            }

            window.location.href = Routes.ContinueOnboarding;

            return { type: NOOP };
          },
        },
      };

      Cookies.set('email', email);
      await dispatch(guestRegistrationTermsSubmitted(action));
    },
    [dispatch, allValues],
  );
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`, {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
            Accept: 'application/json',
          },
        })
        .then((res) => {
          if (res.data?.verified_email) {
            onSubmitSendData(res.data.email, tokenResponse.access_token);
          }
        })
        .finally(() => setDisabled(false))
        .catch((err) => console.log(err));
    },
    onNonOAuthError: (_) => {
      setDisabled(false);
    },
  });

  const handleClick = useCallback(() => {
    setDisabled(true);
    login();
  }, [login]);
  return (
    <Card>
      <Card.Body>
        <div>
          <h4 className="mb-2">Next, let’s set up an account for you.</h4>
          <p>This will be used as your sign in for future access to the Maximus portal.</p>
          <p className="mt24">Your doctor and pharmacy will also use this to deliver your treatment.</p>
        </div>
        <div>
          <Button className="google-button" disabled={disabled} onClick={handleClick}>
            <img className="mr12" width="18" height="18" src={GoogleIcon} alt="Google" /> Continue with Google
          </Button>
          <a onClick={() => setWithEmail(true)} className="mt24 text-center block bold" data-testid="login-with-email">
            Continue with email
          </a>
        </div>
        {withEmail && <AccountRegistrationStep allValues={allValues} trackSegmentEvent={trackSegmentEvent} />}
      </Card.Body>
    </Card>
  );
};

export default LoginType;
